import { ClassValue, clsx } from 'clsx';
interface MessageProps {
  className?: ClassValue;
  error?: Error;
  resetErrorBoundary?: () => void;
}

function Message({ className }: MessageProps) {
  return (
    <div
      className={clsx(
        'flex items-center justify-center w-full h-full py-sm rounded-radius-sm bg-surface-light',
        className,
      )}>
      <div className="text-label-large text-content-light">Something went wrong</div>
    </div>
  );
}

export { Message };
